var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('purchase-sector', {
    attrs: {
      "title": "결제수단"
    }
  }, [_c('v-sheet', {
    staticClass: "pa-6",
    attrs: {
      "color": "grey lighten-3"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2"
  }, [_vm._l(_vm.items, function (item) {
    return [_c('v-col', {
      key: item.value,
      staticClass: "pa-2",
      attrs: {
        "cols": "12"
      }
    }, [_c('purchase-method-item', _vm._b({
      attrs: {
        "value": _vm.method
      },
      on: {
        "input": _vm.emit
      }
    }, 'purchase-method-item', {
      item: item
    }, false))], 1)];
  })], 2)], 1), _c('purchase-method-noti', {
    ref: "purchase-method-noti"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }